/** @format */

import { AuthInterceptor } from '@shared/authentication/data-access';
import { CommonInterceptor, PlatformInterceptor } from '@shared/data-access/config';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LogInterceptor } from '@logger';

/* Http interceptor providers in outside-in order */
export const HTTP_INTERCEPTOR_PROVIDERS = [
	{ provide: HTTP_INTERCEPTORS, useClass: PlatformInterceptor, multi: true },
	{ provide: HTTP_INTERCEPTORS, useClass: LogInterceptor, multi: true },
	{ provide: HTTP_INTERCEPTORS, useClass: CommonInterceptor, multi: true },
	{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
];
